module.exports = __webpack_public_path__ + "static/media/booklist-thumbnail.4808fb77.png";